import DetectDesktopOrMobile from './DetectDesktopOrMobile';
export default DetectDesktopOrMobile;